export default __webpack_public_path__ + "static/layersinglebend-c80022c472041e264aa36cd6163ab48d.png";